// Invitation secrets stay in the fragment and in memory, never in API URLs or preferences.
export function fleetInvitationCode(value){
 if(typeof value!=='string')return null;
 if(value.startsWith('#'))return /^#fleet-invitation=([A-Za-z0-9_-]{32})$/.exec(value)?.[1]??null;
 try{
  const url=new URL(value);
  if(url.origin==='https://app.qtracker.dk'&&url.pathname==='/')return fleetInvitationCode(url.hash);
  if(url.protocol==='qsmart:'&&url.hostname==='fleet-invitation')return /^\/([A-Za-z0-9_-]{32})$/.exec(url.pathname)?.[1]??null;
 }catch{}
 return null;
}
